module.exports = __webpack_public_path__ + "9779d9a1/img/menu-icon.5f8facae.svg";